<template>
  <div class="ZeroContactSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="ZeroContactSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
        <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="ZeroContactSettings-main lxn-pos-rel">
      <div class="ZeroContactSettings-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{ $store.getters.language.texts.ZeroContactSettings_title1 }}
          </template>
          <template v-slot:body>
            <div class="ZeroContactSettings-wrapper-inputState lxn-w100">
              <div
                class="ZeroContactSettings-wrapper-inputState-d0 lxn-text"
                :class="[$store.getters.language.floatClass, $store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]"
              >
                {{ $store.getters.language.texts.ZeroContactSettings_text1 }}
              </div>
              <div class="ZeroContactSettings-wrapper-inputState-d1 lxn-text" :class="$store.getters.language.floatClassReverse">
                <ButtonIcon :size="40" bgColor="#DEDEDE" :icon="zeroContactStateIcon" iconColor="#1EA5DE" :padding="8" />
              </div>
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{ $store.getters.language.texts.ZeroContactSettings_title2 }}
          </template>
          <template v-slot:body>
            <div
              class="ZeroContactSettings-wrapper-fieldTitle lxn-w100 lxn-text"
              :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]"
            >
              {{ $store.getters.language.texts.ZeroContactSettings_text2 }}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="currentInputType" :dropDownContex="dropDown1Data" />
            </div>
            <div
              class="ZeroContactSettings-wrapper-fieldTitle lxn-w100 lxn-text"
              :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]"
            >
              {{ $store.getters.language.texts.ZeroContactSettings_text3 }}
            </div>
            <div class="lxn-w100">
              <customInput
                @focus="inputFieldState = 'active'"
                @blur="inputFieldState = ''"
                :inputState="inputFieldState"
                v-model="currentInputName"
                bgColor="#FFFFFF"
                :placeHolder="$store.getters.language.texts.AddNodeNameColor_placeHolder"
                inputType="text"
              />
            </div>
            <div v-if="node.deviceType != 14">
              <div
                class="ZeroContactSettings-wrapper-fieldTitle lxn-w100 lxn-text"
                :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]"
              >
                {{ $store.getters.language.texts.ZeroContactSettings_title3 }}
              </div>
              <div class="lxn-w100 lxn-dir-rtl lxn-text lxn-text-fa">
                <input type="radio" ref="sendConnectNotification" v-model="connectionNotif" @change="enablePhoneInput" value="sendConnectNotification" />
                <label for="jack">{{ $store.getters.language.texts.ZeroContactSettings_text6 }}</label>
              </div>
              <div class="lxn-w100 lxn-dir-rtl lxn-text lxn-text-fa">
                <input type="radio" ref="sendDisconnectNotification" v-model="connectionNotif" @change="enablePhoneInput" value="sendDisconnectNotification" />
                <label for="jack">{{ $store.getters.language.texts.ZeroContactSettings_text7 }}</label>
              </div>
              <div class="lxn-w100 lxn-dir-rtl lxn-text lxn-text-fa">
                <input type="radio" ref="sendBothNotification" v-model="connectionNotif" @change="enablePhoneInput" value="sendNoNotification" />
                <label for="jack">{{ $store.getters.language.texts.ZeroContactSettings_text9 }}</label>
              </div>
              <div style="height: 8px"></div>
              <div class="lxn-w100">
                <!-- <customInput
                  :disabled="!connectionNotif"
                  @input="updatePhonevalidationStatus"
                  @focus="inputFieldState = 'active'"
                  @blur="inputFieldState = ''"
                  :inputState="inputFieldState"
                  :class="$store.getters.language.floatClass"
                  v-model="phoneNumber"
                  bgColor="#FFFFFF"
                  :placeHolder="$store.getters.language.texts.ZeroContactSettings_phoneInput_placeHolder"
                  inputType="number"
                  float="left"
                  style="width: calc(100% - 48px)"
                  :style="addPhoneBtnStyle"
                  :error="phoneNumberError"
                /> -->
                <!-- <CustomButton
                  bgColor="#1EA5DE"
                  iconRight="plus"
                  iconRightColor="#1EA5DE"
                  iconRightBgColor="#D5E6F0"
                  textColor="#FFFFFF"
                  :iconRightPadding="0"
                  :useLanguageDirection="true"
                  width="48"
                  @click="addPhoneNumber"
                >
                </CustomButton> -->
            </div>
          </div>
            <div style="height: 8px"></div>
            <!-- <CustomMultiselectChips :items="phoneNumbers" /> -->
            <!-- <div class="ZeroContactSettings-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.ZeroContactSettings_text4}}
            </div> -->
            <!-- <div class="lxn-w100">
              <DropDown v-model="currentInitialState" :dropDownContex="dropDown1Data" :disabled="isNodeOffline || isHubOffline" />
            </div> -->
            <!-- <div class="ZeroContactSettings-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.ZeroContactSettings_text5}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="currentInputImpact" :dropDownContex="dropDown2Data" />
            </div> -->
          </template>
        </TitleBox>
      </div>
      <div class="ZeroContactSettings-button lxn-margin-auto lxn-w100">
        <CustomButton
          @click="saveChanges"
          bgColor="#1EA5DE"
          iconRight="arrowRight"
          iconRightColor="#1EA5DE"
          iconRightBgColor="#D5E6F0"
          textColor="#FFFFFF"
          :iconRightPadding="8"
          :useLanguageDirection="true"
        >
          {{ $store.getters.language.texts.ZeroContactSettings_button }}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ButtonIcon from "@/components/ButtonIcon.vue";
import CustomButton from "@/components/CustomButton.vue";
import CustomCurve from "@/components/CustomCurve.vue";
import CustomInput from "@/components/CustomInput.vue";
// import CustomMultiselectChips from "@/components/CustomMultiselectChips.vue";
import DropDown from "@/components/DropDown.vue";
import TitleBox from "@/components/TitleBox.vue";
import TopNav from "@/components/TopNav.vue";
import * as CONFIGS from "@/statics/configs.js";
import NODE5 from "@/statics/devices/Node5/header.js";
import Logger from "@/statics/logger.js";
import Messaging from "@/statics/messaging.js";

export default {
  name: "ZeroContactSettings",
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    ButtonIcon,
    DropDown,
    // CustomMultiselectChips,
  },
  data: function () {
    return {
      inputFieldState: "",
      node: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID),
      currentInputName: "",
      currentInputType: 0,
      currentInputImpact: 0,
      connectionNotif: true,
      phoneNumber: "",
      phoneNumbers: [],
      phoneNumberError: { hasError: false, message: "" },
    };
  },
  mounted: function () {
    this.$store.commit("setAppBusy", true);
    this.currentInputName = this.inputName;
    this.currentInputType = this.input.settings.inputType;
    this.currentInputImpact = this.inputImpact;

    var messagingHook = new Messaging(new Logger(false));
    messagingHook.init({
      psk: this.hub.psk,
      destinationUUID: this.hub.uuid,
      sourceUUID: this.$store.state.user.uuid,
    });
    this.$store
      .dispatch("readNodeInstructions", {
        messagingHook: messagingHook,
        hubUUID: this.hub.uuid,
        nodeUUID: this.node.uuid,
      })
      .then((response) => {
        // check instruction to find notification:
        var sensorInstructionList = response.body.bodyContent.instructionList;
        this.$store
          .dispatch("readEventNotifications", {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
          })
          .then((response) => {
            let found = false;
            var notificationsList = response.body.bodyContent.notificationsList;
            for (var i = 0; i < sensorInstructionList.length; i++) {
              if (sensorInstructionList[i].internalAction.parameterId === this.nodeHeader.NOTIFY_HUB.PARAMETER_ID) {
                for (var j = 0; j < notificationsList.length; j++) {
                  if (notificationsList[j].eventId === sensorInstructionList[i].internalAction.valueOfChange) {
                    found = true;
                    if (sensorInstructionList[i].eventToWatch.valueToReach === CONFIGS.INPUT_CONNECT_VALUE) {
                      this.connectionNotif = "sendConnectNotification";
                    } else {
                      this.connectionNotif = "sendDisconnectNotification";
                    }
                  }
                }
                if (found === false) {
                  this.connectionNotif = "sendNoNotification";
                }
              }
            }
          });
        this.$store
          .dispatch("readNodeParameters", {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.node.uuid,
          })
          .then((response) => {
            this.$store.dispatch("processNodeParameters", {
              rawParameters: response.body.bodyContent.parameterList,
              nodeUUID: this.node.uuid,
            });
            this.$store.commit("setHubStatus", {
              hubIndex: response.hubIndex,
              stateUpdateEnabled: true,
            });
          })
          .catch((response) => {
            if (response.rejectCode == 2) {
              this.$store.commit("setHubStatus", {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            } else {
              this.$store.commit("setHubStatus", {
                hubIndex: response.hubIndex,
                stateUpdateEnabled: true,
              });
            }
          });
      })
      .catch((response) => {
        if (response.rejectCode == 2) {
          this.$store.commit("setHubStatus", {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        } else if (response.rejectCode == 1) {
        
          //TODO: node is offline, handle it here
          // this.$store.commit('setHubStatus', {
          //   hubIndex: hub.index,
          //   stateUpdateEnabled: true,
          // });
        } else {
        
          //reject code is 3 here.
          //TODO: hub is not online yet
          //handle it here
        }
      });

    // this.$store
    //   .dispatch("readEventNotifications", {
    //     messagingHook: messagingHook,
    //     hubUUID: this.hub.uuid,
    //   })
    //   .then((response) => {
  
    //   });
    this.$store.commit("setAppBusy", false);
  },
  destroyed: function () {
    this.$store.commit("cancelAllStateUpdates");
  },
  computed: {
    currentNotifications: function () {
      let notifications = undefined;
      for (let i = 0; i < this.$store.state.notifications.length; i++) {
        let notification = this.$store.state.notifications[i];
        if (notification.hubUUID == this.hub.uuid && notification.settings.nodeUUID == this.node.uuid && notification.settings.input == this.$route.params.inputIndex) {
          return notification;
        }
      }
      return notifications;
    },
    nodeHeader: function () {
      if (this.node.deviceType == 5) {
        return NODE5;
      } else {
        return NODE5;
      }
    },
    inputImpact: function () {
      return 0;
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    input: function () {
      return this.node.inputs[this.$route.params.inputIndex];
    },
    inputParameterId: function () {
    
      return this.node.inputs[this.$route.params.inputIndex].parameterId;
    },
    inputName: function () {
      return this.input.name;
    },
    isNodeOffline: function () {
      if (this.node.connectionStatus == 1) {
        return false;
      } else {
        return true;
      }
    },
    isHubOffline: function () {
      if (this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2) {
        return false;
      } else {
        return true;
      }
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.node.color];
    },
    zeroContactState: function () {
      var zeroContactState = this.$store.getters.getParameterValue(this.node.index, this.input.parameterId);
      if (zeroContactState == undefined) {
        return 0;
      } else {
        return zeroContactState;
      }
    },
    zeroContactStateIcon: function () {
      if (this.isNodeOffline || this.isHubOffline) {
        return "offline";
      }
      if (this.zeroContactState) {
        return "local";
      } else {
        return "online";
      }
    },
    floatClass: function () {
      if (this.float == undefined) {
        return "";
      }
      return "lxn-float-" + this.float;
    },
    addPhoneBtnStyle: function () {
      if (this.$store.getters.language.directionClass.includes("rtl")) {
        return {
          paddingLeft: "8px",
        };
      } else {
        return {
          paddingRight: "8px",
        };
      }
    },
    // currentSwitchStateText: function () {
    //   if(this.currentSwitchState == 'on'){
    //     return this.$store.getters.language.texts.ZeroContactSettings_switchState_On;
    //   }else if(this.currentSwitchState == 'off'){
    //     return this.$store.getters.language.texts.ZeroContactSettings_switchState_Off;
    //   }
    // },
    // initialState: function () {
    //   var initialState = this.$store.getters.getParameterValue(this.node.index, this.output.initialStateParameterId);
    //   if(initialState == undefined){
    //     return 0;
    //   }else{
    //     return initialState;
    //   }
    // },
    // currentSwitchStateColor: function () {
    //   if(this.currentSwitchState == 'on'){
    //     return 'color: #2FBAEE';
    //   }else if(this.currentSwitchState == 'off'){
    //     return 'color: #52626C';
    //   }
    // },
    dropDown1Data: function () {
      return {
        name: "ZeroContactSettings-inputInitialState",
        title: this.$store.getters.language.texts.ZeroContactSettings_text2,
        selectedIndex: this.currentInputType,
        data: [
          {
            name: this.$store.getters.language.texts.ZeroContactSettings_inputType1,
            icon: "lamp",
          },
          {
            name: this.$store.getters.language.texts.ZeroContactSettings_inputType2,
            icon: "lamp",
          },
          {
            name: this.$store.getters.language.texts.ZeroContactSettings_inputType3,
            icon: "lamp",
          },
          {
            name: this.$store.getters.language.texts.ZeroContactSettings_inputType4,
            icon: "lamp",
          },
        ],
      };
    },
    // dropDown2Data: function () {
    //   return {
    //     name: "ZeroContactSettings-inputImpact",
    //     title: this.$store.getters.language.texts.ZeroContactSettings_text5,
    //     selectedIndex: this.currentInputImpact,
    //     data: [
    //       {
    //         name: this.node.outputs[0].name,
    //         icon: 'lamp',
    //       },
    //       {
    //         name: this.node.outputs[1].name,
    //         icon: 'lamp',
    //       },
    //     ]
    //   }
    // },
  },
  methods: {
    addPhoneNumber: function () {
      if (this.phoneNumbers.indexOf(this.phoneNumber) === -1 && this.phoneNumber !== "") {
        this.phoneNumbers.push(this.phoneNumber);
      } else {
        this.updatePhonevalidationStatus();
      }
    },
    updatePhonevalidationStatus: function () {
      if (this.phoneNumbers.indexOf(this.phoneNumber) > -1) {
        this.phoneNumberError.hasError = true;
        this.phoneNumberError.message = this.$store.getters.language.texts.Duplicate_PhoneNumber;
      } else if (this.phoneNumber === "") {
        this.phoneNumberError.hasError = false;
      } else {
        this.phoneNumberError.hasError = false;
      }
    },
    enablePhoneInput: function () {
      // TODO: if the phone number input is required then use this to enable phone numebr input field, currently phone input is hidden
    },
    goBack: function () {
      this.$router.go(-1);
    },
    saveChanges: function () {
      this.inputFieldState = "";
      if (this.currentInputName == "") {
        this.inputFieldState = "error";
        alert(this.$store.getters.language.texts.ZeroContactSettings_alert);
      } else {
        this.$store.commit("setAppBusy", true);
        this.$store.commit("setNodeInputName", {
          nodeIndex: this.node.index,
          inputIndex: this.$route.params.inputIndex,
          name: this.currentInputName,
        });
        this.$store.commit("setNodeInputType", {
          nodeIndex: this.node.index,
          inputIndex: this.$route.params.inputIndex,
          type: this.currentInputType,
        });
        this.$store.commit("saveState");
        //TODO: check hub connection here too
        //TODO: check hub connection for single switch and init state too
        // if(!this.isNodeOffline && !this.isHubOffline && this.initialState != this.currentInitialState){
        //   var messagingHook = new Messaging(new Logger(false));
        //   messagingHook.init({
        //     psk: this.hub.psk,
        //     destinationUUID: this.hub.uuid,
        //     sourceUUID: this.$store.state.user.uuid
        //   });
        //   this.$store.dispatch('setNodesParameters', {
        //     messagingHook: messagingHook,
        //     hubUUID: this.hub.uuid,
        //     nodeUUID: this.node.uuid,
        //     bodyContent: {
        //       nodeCount: 1,
        //       nodeActions: [
        //         {
        //           nodeUUID: this.node.uuid,
        //           actionCount: 1,
        //           actions: [
        //             {
        //               parameterId: this.output.initialStateParameterId,
        //               valueOfChange: this.currentInitialState,
        //               typeOfAction: ACTION_TYPE_SET,
        //               timeDelay: 0
        //             }
        //           ]
        //         }
        //       ]
        //     }
        //   })
        //   .then( response => {
        //     this.$router.push('/Home/Devices');
        //     this.$store.commit('setAppBusy', false);
        //   })
        //   .catch( response => {
        //     if(response.rejectCode == 1){
        //       this.$router.push('/SettingsNodeError');
        //     }else if(response.rejectCode == 2){
        //       this.$router.push('/SettingsHubError');
        //       this.$store.commit('setHubStatus', {
        //         hubIndex: response.hubIndex,
        //         connectionStatus: {
        //           local: HUB_CONNECTION_STATUS_DISCONNECTED,
        //           online: HUB_CONNECTION_STATUS_DISCONNECTED,
        //         },
        //       });
        //     }else{
        //       this.$router.push('/SettingsHubError');
        //     }
        //     this.$store.commit('setAppBusy', false);
        //   });
        // }else{
        //   this.$router.push('/Home/Devices');
        //   this.$store.commit('setAppBusy', false);
        // }
        // this.$router.push("/Home/Devices");
        this.$store.commit("setAppBusy", false);
      }
      this.$store.commit("setAppBusy", true);
      var hub = this.$store.getters.getHubByUUID(this.hub.uuid);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: hub.uuid,
        sourceUUID: this.$store.state.user.uuid,
      });
      this.$store
        .dispatch("readNodeInstructions", {
          messagingHook: messagingHook,
          hubUUID: this.hub.uuid,
          nodeUUID: this.node.uuid,
        }).then((response) => {
          let currentInstructionIndex = undefined;
          let currentEventNotificationIndex = undefined;
          let eventNotifications = undefined;
          var sensorInstructionList = response.body.bodyContent.instructionList;
          this.$store
            .dispatch("readEventNotifications", {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
            })
            .then((response) => {
              let notificationsList = response.body.bodyContent.notificationsList;
              let found = false;
              for (let i = 0; i < sensorInstructionList.length; i++) {
                if (sensorInstructionList[i].internalAction.parameterId === this.nodeHeader.NOTIFY_HUB.PARAMETER_ID) {
                  for (var j = 0; j < notificationsList.length; j++) {
                    if (notificationsList[j].eventId === sensorInstructionList[i].internalAction.valueOfChange) {
                      currentInstructionIndex = i;
                      currentEventNotificationIndex = j;
                      found = true;
                      break;
                    }
                  }
                  if (found === true) {
                    break;
                  }
                }
              }
              eventNotifications = notificationsList;
              if (this.connectionNotif === "sendNoNotification") {
                if (currentInstructionIndex !== undefined) {
                  // delete current notification when send no notification has been chosen.
                  eventNotifications[currentEventNotificationIndex].isNotified = false;
                  this.$store
                    .dispatch("setEventNotifications", {
                      messagingHook: messagingHook,
                      hubUUID: hub.uuid,
                      bodyContent: {
                        notificationsList: [eventNotifications[currentEventNotificationIndex]],
                      },
                    })
                    .then(() => {
                      this.$store
                        .dispatch("readNotifications", {
                          hubUuid: hub.uuid,
                          userUuid: this.$store.state.user.uuid,
                        })
                        .then((response) => {
                          for (let i = 0; i < response.data.notifications.length; i++) {
                            if (eventNotifications[currentEventNotificationIndex].eventId === response.data.notifications[i].notificationCode) {
                              this.$store
                                .dispatch("deleteNotifications", {
                                  hubUuid: hub.uuid,
                                  userUuid: this.$store.state.user.uuid,
                                  _id: response.data.notifications[i]._id,
                                })
                                .then((response) => {
                                  this.$store.commit("deleteNotificationByEventId", eventNotifications[currentEventNotificationIndex].eventId);
                                  this.$store.commit("saveState");
                                  // if (response.data.status != "success" && response.data.status != "notValidId" && response.data.status != "failure") {
                                  //   alert(this.$store.getters.language.texts.AddNewUser_serverResponseFail);
                                  // }
                                })
                                .catch((response) => {
                                  eventNotifications[currentEventNotificationIndex].isNotified = true;
                                  this.$store.dispatch("setEventNotifications", {
                                    messagingHook: messagingHook,
                                    hubUUID: hub.uuid,
                                    bodyContent: {
                                      notificationsList: [eventNotifications[currentEventNotificationIndex]],
                                    },
                                  });
                                  alert(this.$store.getters.language.texts.ZeroContactSetting_internetError);
                                });
                            }
                          }
                        })
                        .catch((response) => {
                          alert(this.$store.getters.language.texts.ZeroContactSetting_internetError);
                        });
                    })
                    .catch((response) => {
                      if (response.rejectCode == 2) {
                        this.$store.commit("setHubStatus", {
                          hubIndex: response.hubIndex,
                          connectionStatus: {
                            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                          },
                        });
                      }
                      alert(this.$store.getters.language.texts.ZeroContactSetting_AlertHubFailed);
                      this.$store.commit("setHubStatus", {
                        hubIndex: this.hub.index,
                        stateUpdateEnabled: true,
                      });
                      this.$store.commit("setAppBusy", false);
                      return;
                    });
                }
                this.$store.commit("setAppBusy", false);
                return;
              } else {
                // add notification
                let eventId = undefined;
                let newNotificationsList = [];
                if (currentEventNotificationIndex !== undefined) {
                  // pick up the old event notification for this inout to set new changes 
                  eventId = eventNotifications[currentEventNotificationIndex].eventId;
                } else {
                  // there is not any notification for this input create new eventId 
                  let eventIds = eventNotifications.map((eventNotification) => {
                    eventNotification.eventId;
                  });
                  let eventIdNotFound = true;
                  while (eventIdNotFound) {
                    let randomNum = Math.random() * 256;
                    randomNum = Math.floor(randomNum);
                    eventId = (CONFIGS.NOTIFICATION_EVENT_ID_PREFIX << 8) + (randomNum & 0xff);
                    if (eventIds.indexOf(eventId) === -1) {
                      eventIdNotFound = false;
                    }
                  }
                }
                let newInstruction = {
                  eventToWatch: {
                    parameterId: this.inputParameterId,
                    valueToReach: CONFIGS.INPUT_CONNECT_VALUE,
                    direction: CONFIGS.EVENT_DIRECTION_ANY,
                  },
                  internalAction: {
                    parameterId: this.nodeHeader.NOTIFY_HUB.PARAMETER_ID,
                    valueOfChange: eventId,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  },
                  timeDelay: 0,
                };
                if (this.connectionNotif == "sendConnectNotification") {
                  newInstruction.eventToWatch.valueToReach = CONFIGS.INPUT_CONNECT_VALUE;
                } else if (this.connectionNotif == "sendDisconnectNotification") {
                  newInstruction.eventToWatch.valueToReach = CONFIGS.INPUT_DISCONNECT_VALUE;
                }
                if (currentInstructionIndex === undefined) {
                  // sensorInstructionList.push(newInstruction);
                  // check for the old instruction with notfiy hub internal action parameterid  and current input parameterid as eventtowatch parameterid
                  let found = false;
                  for (let k=0; k< sensorInstructionList.length; k ++){
                    if (sensorInstructionList[k].internalAction.parameterId == this.nodeHeader.NOTIFY_HUB.PARAMETER_ID && sensorInstructionList[k].eventToWatch.parameterId ==  this.inputParameterId && sensorInstructionList[k].eventToWatch.valueToReach == newInstruction.eventToWatch.valueToReach) {
                      sensorInstructionList[k] = newInstruction;
                      found = true; 
                    }
                  }
                  if (!found) {
                    sensorInstructionList.push(newInstruction);
                  }
                } else {
                  sensorInstructionList[currentInstructionIndex] = newInstruction;
                }
                newNotificationsList.push({
                  isNotified: true,
                  eventId: eventId,
                });
                this.$store
                  .dispatch("setInstructionsOnDevice", {
                    messagingHook: messagingHook,
                    hubUUID: this.hub.uuid,
                    nodeUUID: this.node.uuid,
                    instructions: sensorInstructionList,
                  })
                  .then(() => {
                    // this.$store.commit("setAppBusy", false)
                    this.$store
                      .dispatch("setEventNotifications", {
                        messagingHook: messagingHook,
                        hubUUID: hub.uuid,
                        bodyContent: {
                          notificationsList: newNotificationsList,
                        },
                      })
                      .then(() => {
                        this.$store
                          .dispatch("addNotifications", {
                            hubUuid: hub.uuid,
                            userUuid: this.$store.state.user.uuid,
                            aux_auth_token: this.$store.state.user.loginToken,
                            notificationCode: eventId,
                            action: {
                              type: 0x01,
                              place: hub.name,
                              sensor: this.input.name,
                            },
                          })
                          .then((response) => {
                            let notification = {
                                eventId: eventId,
                                notifyOnconnect: this.connectionNotif == "sendConnectNotification" ?  true : false,
                                notirfyOnDisonnect: this.connectionNotif == "sendDisconnectNotification" ?  true : false, 
                                nodeUUID: this.node.uuid,
                                hubUUID: this.hub.uuid,
                                input: this.input 
                              }  
                            if (currentEventNotificationIndex !== undefined) {
                              this.$store.commit("editOrAddNotificationByEventId", notification);
                            } else {
                              this.$store.commit("addNotification", notification);
                            }
                            this.$store.commit("saveState");
                            // if (response.data.status != "success" && response.data.status != "notValidId" && response.data.status != "failure") {
                            //   alert(this.$store.getters.language.texts.AddNewUser_serverResponseFail);
                            // }
                          })
                          .catch((response) => {
                            newNotificationsList[newNotificationsList.length - 1].isNotified = false;
                            this.$store.dispatch("setEventNotifications", {
                              messagingHook: messagingHook,
                              hubUUID: hub.uuid,
                              bodyContent: {
                                notificationsList: newNotificationsList,
                              },
                            });
                            alert(this.$store.getters.language.texts.ZeroContactSetting_internetError);
                          });

                        this.$store.commit("setAppBusy", false);
                      })
                      .catch((response) => {
                        // catch setEventNotifications
                        if (response.rejectCode == 2) {
                          this.$store.commit("setHubStatus", {
                            hubIndex: response.hubIndex,
                            connectionStatus: {
                              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                            },
                          });
                        }
                        alert(this.$store.getters.language.texts.AlertHubFailed);
                        this.$store.commit("setAppBusy", false);
                      });
                  })
                  .catch(() => {
                    alert(this.$store.getters.language.texts.AlertٔNodeFailed);
                    this.$store.commit("setHubStatus", {
                      hubIndex: this.hub.index,
                      stateUpdateEnabled: true,
                    });
                    this.$store.commit("setAppBusy", false);
                  })
                  .finally(() => {

                    this.$store.commit("setHubStatus", {
                      hubIndex: this.hub.index,
                      stateUpdateEnabled: true,
                    });
                    this.$store.commit("setAppBusy", false);
                  });
              }
            })
            .catch((response) => {
              if (response.rejectCode == 2) {
                this.$store.commit("setHubStatus", {
                  hubIndex: response.hubIndex,
                  connectionStatus: {
                    local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                    online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  },
                });
              }
              alert(this.$store.getters.language.texts.AlertHubFailed);
              this.$store.commit("setHubStatus", {
                hubIndex: this.hub.index,
                stateUpdateEnabled: true,
              });
              this.$store.commit("setAppBusy", false);
            });
          return;
        })
        .catch(() => {
          alert(this.$store.getters.language.texts.AlertٔNodeFailed);
          this.$store.commit("setHubStatus", {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
          this.$store.commit("setAppBusy", false);
        });
    },
  },
};
</script>

<style>
.ZeroContactSettings-topCurve-wrapper {
  height: 200px;
}
.ZeroContactSettings-main {
  z-index: 2;
}
.ZeroContactSettings-main-wrapper {
  width: calc(100% - 36px);
  margin-top: -150px;
  background-color: #ffffff;
  margin-bottom: 14px;
  padding: 14px;
}
.ZeroContactSettings-wrapper-inputState {
  height: 50px;
}
.ZeroContactSettings-wrapper-inputState-d0 {
  line-height: 50px;
}
.ZeroContactSettings-wrapper-inputState-d1 {
  padding-top: 5px;
}

.ZeroContactSettings-button {
  width: calc(100% - 36px);
  margin-bottom: 14px;
}
.ZeroContactSettings-wrapper-outputState {
  height: 50px;
  color: #52626c;
  line-height: 50px;
}
.ZeroContactSettings-wrapper-outputState-right {
  width: calc(100% - 84px);
}
.ZeroContactSettings-wrapper-outputState-left {
  width: 70px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.ZeroContactSettings-wrapper-fieldTitle:first-child {
  height: 25px;
  line-height: 25px;
  padding-top: 0;
}
.ZeroContactSettings-wrapper-fieldTitle {
  height: 35px;
  padding-top: 10px;
  line-height: 25px;
  color: #52626c;
}
</style>
